import React, { PropsWithChildren } from "react";

type InputLabelWrapperProps = {
  labelName: string | React.ReactNode;
  col?: number;
  className?: string;
  labelClassName?: string;
  flexDirection?: "row" | "column" | "row-reverse" | "column-reverse";
  hidden?: boolean;
};

const InputLabelWrapper: React.FC<PropsWithChildren<InputLabelWrapperProps>> = props => {
  const { labelName, col, className, labelClassName, children, flexDirection, hidden = false } = props;
  if (hidden) return null;

  return (
    <div
      className={`flex flex-${flexDirection ?? "column"} justify-content-between gap-1 w-full md:w-${col ?? 6} col-${
        col ?? 6
      } ${className}`}
    >
      <label className={labelClassName}>{labelName}</label>
      {children}
    </div>
  );
};

export default InputLabelWrapper;
